import { useSelector } from "react-redux";
import { userStateSelector } from "./userStateSelector";

export function useUserAccount() {
    const { account } = useSelector(userStateSelector);
    return account;
}

export const useConnectedWallet = useUserAccount;
